import { CircularProgress, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, SelectProps } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import { DocumentTypesList } from '../../models/DocumentTypes';
import { RuleValidationInterface } from '../../shared/hooks/useRuleValidation';
import { v4 as uuidv4 } from 'uuid';
import CustomArrowIcon from '../../components/CustomArrowIcon/CustomArrowIcon';

interface SelectDocumentTypeInterface {
  onChange: (event:SelectChangeEvent<HTMLSelectElement>) => void,
  value: string
  name: string
  size?: SelectProps['size']
  multiColumn?: boolean
  rule?: RuleValidationInterface
  showLoading: boolean
  disabled?: boolean
}

const SelectDocumentType:React.FC<SelectDocumentTypeInterface> = ({ onChange, value, name, size, multiColumn, rule, showLoading, disabled }) => {
  const handleChange = (e:SelectChangeEvent<HTMLSelectElement>) => {
    onChange(e);
  };

  return (
    <FormControl fullWidth {...(multiColumn ? { sx: { width: '370px' } } : {})} >
      <InputLabel id="demo-simple-select-label" tabIndex={-1}>
        <>{t('documentType')}</>
      </InputLabel>
      <Select
        IconComponent={(props) => (
          <CustomArrowIcon {...props} testId="document-type-select-arrow" />
        )}
        inputProps={{ tabIndex: 6, 'data-testid': 'document-type-select',}}
        size={size ?? 'small'}
        name={name}
        sx={[{ '& .MuiInputAdornment-root': { position: 'absolute', right: '2rem' } },
          { '& .MuiCircularProgress-root': { position: 'absolute', right: '2.5rem' } },
          { root: { width: '100%' } }
        ]}
        label={<>{t('documentNumber')}</>}
        placeholder={t('documentNumber')}
        onChange={handleChange}
        value={value as unknown as HTMLSelectElement}
        endAdornment={showLoading ? <CircularProgress color="inherit" size={20} /> : rule?.adornment}
        disabled={disabled}
      >
        {DocumentTypesList.map((row) => (
          <MenuItem key={uuidv4()} value={row.value}>
            {row.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl >
  );
};

export default SelectDocumentType;
